import React, { useEffect, useState } from "react";
import {Link} from 'react-router-dom';
import searchIcon from "../images/search.svg";
import profile from "../images/profile.jpg";
import dropdownIcon from "../images/dropdown-icon.svg";
import { userName, logout } from '../../../Utils/FirebaseAuth';
import { auth } from "../../../Services/firebase";
import LogoutModal from "../../shared/logoutModal/logoutModal";

function Navbar(props) {
  const [UserName, setUserName] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [isConfirm, setIsConfirm] = useState(false)
  var user;

  const signOut = () => {
    logout();
    window.location = "/"
  }



  useEffect(() => {
    user = auth().currentUser
    if (user) {
      setUserName(user.displayName)
    }
  }, [])

  let handleChange = (value) => {
    setSearchValue(value)
    props.setValue(value)
  }
  return (
    <>
      {/* Topbar */}
      <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top">
        {/* Sidebar Toggle (Topbar) */}
        <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
          <i className="fa fa-bars" />
        </button>
        {/* Topbar Search */}
        <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
          <div className="input-group">
            <input type="text" className="form-control theme-bg-color border-0 small" onChange={(e) => handleChange(e.target.value)} value={searchValue} placeholder="Search for..." aria-label="Search" aria-describedby="basic-addon2" />
            <div className="input-group-append">
              <button className="btn search-btn pr-4" type="button">
                <img src={searchIcon} className="w-15 mb-1" alt="serach icon" />
              </button>
            </div>
          </div>
        </form>
        {/* Topbar Navbar */}
        <ul className="navbar-nav ml-auto">
            
          {/* Nav Item - User Information */}
          <li className="nav-item dropdown no-arrow">
            <a className="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <img className="img-profile rounded-circle" src={profile} />

              <div className="profile-div ml-2">
                <span className="mr-2 small profile-name">{UserName}</span>
                <span className="status">Active</span>
              </div>
              <div>
                <img src={dropdownIcon} className="w-9 ml-1 mb-2" alt="dropdown icon" />
              </div>

            </a>
            {/* Dropdown - User Information */}
            <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
              {/* <a className="dropdown-item" href="#">
                <i className="fa fa-user fa-sm fa-fw mr-2 text-gray-400" />
                Profile
              </a>
              <a className="dropdown-item" href="#">
                <i className="fa fa-cogs fa-sm fa-fw mr-2 text-gray-400" />
                Settings
              </a>
              <a className="dropdown-item" href="#">
                <i className="fa fa-list fa-sm fa-fw mr-2 text-gray-400" />
                Activity Log
              </a> */}
              {/* <div className="dropdown-divider" /> */}
              <Link className="dropdown-item" to='/userprofile'>
                <i className="fa fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" />
                Profile Page
              </Link>
              <Link className="dropdown-item" to="/admin/addlisting">
                <i className="fa fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" />
                Add Listing
              </Link>
              <a className="dropdown-item" href="#" onClick={() => setIsConfirm(true)} data-toggle="modal" data-target="#logoutModal">
                <i className="fa fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" />
                Logout
              </a>
              
              {/* <NavLink className='navlinkStyle hoverBlue' href="/userprofile">Profile Page</NavLink> */}
            </div>
          </li>
        </ul>
      </nav>
      {/* End of Topbar */}

      {isConfirm ?
        <LogoutModal isShowModal={isConfirm}
          callback={(type) => {
            if (type == 'logout') {
              signOut()
            }
            else if (type == 'hide') {
              setIsConfirm(false)
            }
          }}
        />
        :
        null
      }
    </>
  )

}
export default Navbar